import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import HowItWorks from "@/components/landing/HowItWorks";
import QuoteForm from "@/components/landing/QuoteForm";
import Faq from "@/components/landing/Faq";
import Footer from "@/components/landing/Footer";

const BG_IMG = "https://images.unsplash.com/photo-1561000297-a1bf07a85fc2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwZnVybml0dXJlJTIwcmVtb3ZhbCUyMGNsZWFyYW5jZXxlbnwwfHx8YmxhY2tfYW5kX3doaXRlfDE3OTI0MzQwMjd8MA&ixlib=rb-4.1.0&q=85";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-ink" data-testid="landing-page">
      <div className="page-bg" aria-hidden="true">
        <img src={BG_IMG} alt="" />
        <div className="page-bg-glow" />
      </div>
      <div className="relative z-10">
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <HowItWorks />
          <QuoteForm />
          <Faq />
        </main>
        <Footer />
      </div>
    </div>
  );
}
